import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface ICreateBookingExternalPaymentReportsProps {
  authorizationDateEnd: Date;
  authorizationDateInit: Date;
  limit?: number;
  order?: 'ASC' | 'DESC';
  page?: number;
  sort?: 'createdAt';
}

export const createBookingExternalPaymentsReportFileService = async ({
  authorizationDateEnd,
  authorizationDateInit,
  limit,
  order,
  page,
  sort,
}: ICreateBookingExternalPaymentReportsProps): Promise<string> => {
  const { data } = await jhsfBookingsApi.post<Blob>(
    '/bookings/external-payments/reports/xlsx',
    {
      authorizationDateEnd,
      authorizationDateInit,
    },
    {
      responseType: 'blob',
      params: {
        limit,
        order,
        page,
        sort,
      },
    },
  );

  const fileUrl = URL.createObjectURL(data);

  return fileUrl;
};
